import { Component } from '@theme/component';

/**
 * Blog post tag filter. Fetches the tag-filtered blog page and swaps the post
 * grid in place instead of navigating, then hides the (now stale) pagination.
 * Selecting "all" reloads the unfiltered blog index.
 *
 * @extends {Component}
 */
class BlogPostFilter extends Component {
  get #grid() {
    return document.querySelector('.blog-posts-container');
  }

  get #pagination() {
    return document.querySelector('.blog-posts .pagination');
  }

  /**
   * @param {PointerEvent} event
   */
  handleClick(event) {
    const button = event.target;
    if (!(button instanceof HTMLElement)) return;

    const { tag } = button.dataset;
    if (!tag) return;

    if (tag === 'all') {
      window.location.reload();
      return;
    }

    for (const pill of this.querySelectorAll('.blog-post-filter__tag')) {
      pill.classList.toggle('is-active', pill === button);
    }

    if (this.#pagination) this.#pagination.style.display = 'none';
    this.#fetchPosts(tag);
  }

  /**
   * @param {string} tag
   */
  async #fetchPosts(tag) {
    const grid = this.#grid;
    if (!grid) return;

    grid.innerHTML = this.#message(this.dataset.loadingText);

    try {
      const response = await fetch(`${this.dataset.blogUrl}/tagged/${tag}`);
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const fetched = doc.querySelector('.blog-posts-container');

      grid.innerHTML = fetched ? fetched.innerHTML : this.#message(this.dataset.emptyText);
    } catch (error) {
      grid.innerHTML = this.#message(this.dataset.errorText);
    }
  }

  /**
   * @param {string | undefined} text
   */
  #message(text) {
    return `<div class="blog-posts-container__message">${text ?? ''}</div>`;
  }
}

if (!customElements.get('blog-post-filter')) {
  customElements.define('blog-post-filter', BlogPostFilter);
}
